import React, { useRef } from 'react';
import { Button, Form } from 'react-bootstrap';
import { BsUpload } from 'react-icons/bs';
import { IoMdClose } from 'react-icons/io';
import { IoAddOutline, IoClose, IoCloudUploadOutline, IoDocumentAttachOutline, IoFileTrayStackedOutline } from 'react-icons/io5';
import SelectDropdown from '../../../common/utils/select-dropdown';
import { format } from 'date-fns';

const CallForm = ({ data, setData, inputError, setInputError }) => {

  const MAX_FILE_SIZE_MB = 1;
  const attachmentPickerRef = useRef(null);

  function handleChange(e) {
    let { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  return (
    <div className='row'>
      <div className='col-xl-6'>
        <Form.Group className="my-3" controlId="callStatus">
          <Form.Label>Status *</Form.Label>
          <SelectDropdown
            searchable={false}
            maxHeight={155}
            options={[
              { label: "Busy", value: "Busy" },
              { label: "Unavailable", value: "Unavailable" },
              { label: "Answered", value: "Answered" },
              { label: "No Answer", value: "No Answer" },
              { label: "Wrong Number", value: "Wrong Number" }
            ]}
            labelField="label"
            valueField="value"
            placeholder="Select"
            selectedValue={data && data.callStatus ? data.callStatus : ""}
            onSelect={(value) => setData({ ...data, callStatus: value })}
            menuClass="shadow"
          />
        </Form.Group>
      </div>
      <div className='col-xl-6'>
        <Form.Group className="my-3" controlId="callDate">
          <Form.Label>Followup Date *</Form.Label>
          <Form.Control
            type="date"
            onChange={handleChange}
            className={inputError && inputError.title ? 'border-danger' : ''}
            value={data && data.callDate ? format(data.callDate, 'yyyy-MM-dd') : ''}
            isInvalid={inputError && inputError.title}
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.title}</Form.Control.Feedback>
        </Form.Group>
      </div>
      <div className='col-xl-12'>
        <Form.Group className="mb-3" controlId="note">
          <Form.Label>Note *</Form.Label>
          <Form.Control
            type="text"
            as="textarea"
            rows={5}
            placeholder="Enter note here..."
            onChange={handleChange}
            className={inputError && inputError.note ? 'border-danger' : ''}
            value={data && data.note}
            isInvalid={inputError && inputError.note}
          />
          <Form.Control.Feedback type="invalid">{inputError && inputError.note}</Form.Control.Feedback>
        </Form.Group>
      </div>
    </div>
  )
}

export default CallForm;